export default "/images/vendor/@coreui/icons/svg/flag/cif-ye.svg?a32628050ade8bc2405a3c2a89965885";